import { defineStore } from 'pinia'
import type { Chat } from '~/types/chat'
import {useAuthFetch} from "~/composables/useAuthFetch";

export const useChatStore = defineStore('chat', {
  state: () => {
    return {
      userId: useCookie('userId'),
      chatList: [],
      messages: [],
      roomId: null,
      selectedChatData: null,
      aiChatData: null,
      currentView: 'list'
    }
  },
  actions: {
    async fetchMessages(roomId: string) {
      const { $socketUtils } = useNuxtApp()

      if (roomId) {
        this.messages = await $socketUtils.getPreviousMessages(roomId)
      }
    },
    async fetchChats() {
      const { $socketUtils } = useNuxtApp()
      try {
        this.chatList = await $socketUtils.getChats()

        return this.chatList
      } catch (error) {
        throw new Error(error)
      }
    },
  },
  getters: {
    getAiMessages(): any {
      return this.aiChatData
    },
    oppositeUserId(): any | null {
      const found = (this.selectedChatData as Chat)?.participants.find(
        p => p.cognitoUserId !== this.userId
      )
      return found ?? null
    },
  },
})
